// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".recommendations-tags[data-v-20a11f24]{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start}@media(max-width:767.98px){.recommendations-tags button[data-v-20a11f24]{font-size:.7rem;padding:.375rem .5rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
